<template>
  <div>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "Verify SSO",
  data() {
    return {
      message: "",
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    adminUrl() {
      return process.env.VUE_APP_BASE_URL.replace("/api", "");
    },
  },
  created() {
    if (this.currentUser && localStorage.getItem("sso")) {
      this.handleSSOLogout();
    } else {
      this.handleLogout();
    }
  },
  methods: {
    redirectToLastVisited() {
      const lastVisitedURL = localStorage.getItem("lastVisitedURL") ?? "";
      if (lastVisitedURL) {
        const [path, hash] = lastVisitedURL.split("#");
        window.location.href = path + (hash ? `#${hash}` : "");
      } else {
        window.location.href = "/home";
      }
    },
    handleLogout() {
      const isChecked = "check" in this.$route.query;
      const isLogout = "logout" in this.$route.query;
      if (isChecked) {
        localStorage.setItem("sso-check", "checked");
      }
      if (!isChecked || isLogout) {
        const redirectUrl = isLogout
          ? process.env.VUE_APP_MAIN_URL + "home"
          : this.adminUrl + "login";
        const cognitoLogoutUrl =
          process.env.VUE_APP_COGNITO_DOMAIN +
          "/logout?client_id=" +
          process.env.VUE_APP_COGNITO_CLIENT_ID +
          "&logout_uri=" +
          encodeURIComponent(redirectUrl);
        window.location.href = cognitoLogoutUrl;
      } else {
        this.redirectToLastVisited();
      }
    },
    handleSSOLogout() {
      this.loading = true;
      this.$store.dispatch("auth/logout", this.currentUser).then(
        (response) => {
          this.loading = false;
          const lastVisitedURL = localStorage.getItem("lastVisitedURL") ?? "";
          localStorage.clear();
          localStorage.setItem("lastVisitedURL", lastVisitedURL);
          if (response.status === "sso_logout_required") {
            localStorage.setItem("sso-check", "checked");
            this.handleLogout();
          } else {
            window.location.href = this.adminUrl + "login";
          }
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
  },
};
</script>
